import { VueEditor } from "vue2-editor";

Vue.component('spark-kiosk-site', {
    //props: ['page'],


    data() {

        return {
            page: [],
            form: new SparkForm({
                id: '',
                heading: '',
                slug: '',
                text: ''
            })
        };
    },
    created() {
        var self = this;
        console.log(JSON.stringify(this.form))
        this.$parent.$on('showSite', function(id) {
            self.getPage(id);
        });
        console.count(this.site)



    },
    mounted(){



    },

    methods: {
        submit(){
            Spark.post('/admin/site', this.form)
            .then(response => {
                this.$parent.showsPage = false;
                console.log(response);
            });
        },
        getPage(id) {
            axios.get('/admin/site/'+id)
                .then(response => {
                    this.site = response.data;
                    this.form.id = this.site.id
                    this.form.heading = this.site.heading
                    this.form.slug = this.site.slug
                    this.form.text = this.site.text
                    console.count(JSON.stringify(this.site));
                });

        },
        /**
         * Get all of the available subscription plans.
         */


        /**
         * Load the user profile for the given user.
         */


        /*

        /**
         * Show the user profile for the given user.
         *
        showPage(user) {
            history.pushState(null, null, '#/users/' + user.id);

            this.loadProfile(user);
        },


        /**
         * Load the user profile for the given user.
         *
        loadProfile(user) {
            this.$emit('showUserProfile', user.id);

            this.showingUserProfile = true;
        }
        */
    }
});






